export default __webpack_public_path__ + "static/media/logo.737ba6e1.png";